module.exports = __webpack_public_path__ + "static/media/soundRest.b2112366.mp3";